export default function intersecting(
  node,
  { rootMargin = '0px', threshold = [1, 1], condition = true } = {}
) {
  if (condition === false) {
    return {}
  }

  let observer
  if (typeof IntersectionObserver !== 'undefined') {
    observer = new IntersectionObserver(handleIntersect, {
      threshold,
      rootMargin,
    })
  }

  let visible = false
  observer.observe(node)

  function handleIntersect(elements) {
    elements.forEach((element) => {
      if (element.isIntersecting) {
        node.dispatchEvent(new CustomEvent('enter'))
        visible = true
      } else if (!element.isIntersecting && visible) {
        node.dispatchEvent(new CustomEvent('leave'))
        visible = false
      }
    })
  }

  return {
    destroy() {
      observer.unobserve(node)
    },
  }
}
